const CREATE_ASSESSMENT = 'CREATE_ASSESSMENT'
const CREATE_ASSESSMENT_SUCCESS = 'CREATE_ASSESSMENT_SUCCESS'
const GET_ALL_ASSESSMENTS = 'GET_ALL_ASSESSMENTS'
const SET_ALL_ASSESSMENTS = 'SET_ALL_ASSESSMENTS'
const GET_ASSESSMENT_BY_ID = 'GET_ASSESSMENT_BY_ID'
const SET_ASSESSMENT_BY_ID = 'SET_ASSESSMENT_BY_ID'
const ACTIVATE_ASSESSMENT = 'ACTIVATE_ASSESSMENT'
const SET_ACTIVATE_ASSESSMENT_SUCCESS = 'SET_ACTIVATE_ASSESSMENT_SUCCESS'

export {
    CREATE_ASSESSMENT,
    CREATE_ASSESSMENT_SUCCESS,
    GET_ALL_ASSESSMENTS,
    SET_ALL_ASSESSMENTS,
    GET_ASSESSMENT_BY_ID,
    SET_ASSESSMENT_BY_ID,
    ACTIVATE_ASSESSMENT,
    SET_ACTIVATE_ASSESSMENT_SUCCESS
}